import * as angular from "angular";
import {IController} from "angular";

export class FulfillmentStepView implements IController {

  step: any;
  items: any;
  selectedStepNumber: number;

  /* @ngInject */
  constructor() {}

  $onInit() {}

}
angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepView', {
    bindings: {
      step: '<',
      items: '<',
      selectedStepNumber: '<'
    },
    template: require('./fulfillment-step-view.html').default,
    controller: FulfillmentStepView
  });
